import { PropsWithChildren } from 'react';
import { listingCardMiniStyles, linkStyle } from './ListingCardMini.styles.css';

export type ListingCardMiniProps = {
    testId: string;
    listingLinkHref?: string;
    trackClick?: () => void;
    isSmall?: boolean;
};

export const ListingCardMini = ({
    testId,
    listingLinkHref,
    trackClick,
    children
}: PropsWithChildren<ListingCardMiniProps>) => (
    <div
        className={listingCardMiniStyles}
        data-name="card"
        data-testid={testId}
    >
        {listingLinkHref ? (
            <a
                className={linkStyle}
                onClick={trackClick}
                href={listingLinkHref}
            >
                {children}
            </a>
        ) : (
            children
        )}
    </div>
);
